<template>
  <div>
    <b-button
      size="sm"
      variant="primary"
      @click="
        $bvModal.show(modalId);
        currentAnnotation = { color: '#FF0000', text: '', fontSize: '9' };
      "
      >{{ buttonText }}</b-button
    >
    <div>
      <div class="list-item" v-for="ann of annotations" :key="ann.id">
        <b-icon-pen-fill
          class="ann-icon"
          @click="
            $bvModal.show(modalId);
            currentAnnotation = ann;
          "
        ></b-icon-pen-fill>
        <b-icon-trash-fill class="ann-icon" @click="deleteAnnotation(ann)"></b-icon-trash-fill>
        <div style="display: inline-block;" class="ml-1">{{ ann.text.slice(0, 24) }}</div>
      </div>
    </div>

    <b-modal :id="modalId" title="PDF Annotations" hide-footer centered>
      <b-form @submit.prevent="addAnnotation" style="text-align: left;">
        <b-form-group label="Text:">
          <b-textarea v-model="currentAnnotation.text"></b-textarea>
        </b-form-group>

        <b-form-group label="Font Color:">
          <b-input v-model="currentAnnotation.color" type="color"></b-input>
        </b-form-group>

        <b-form-group label="Font Size:">
          <b-input v-model="currentAnnotation.fontSize" type="number" min="5" max="40"></b-input>
        </b-form-group>

        <b-button size="sm" type="submit">Done</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { randomId } from "../modules/utils";
import { EventBus } from "../modules/eventBus";
export default {
  name: "pdf-annotations",
  props: {
    name: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: "Add Annotation",
    },
  },
  data() {
    return {
      annotations: [],
      currentAnnotation: {
        text: "",
        color: "#FF0000",
        fontSize: "9",
      },
    };
  },
  methods: {
    addAnnotation() {
      if (!this.currentAnnotation.id) {
        this.annotations.push({
          ...this.currentAnnotation,
          id: randomId(),
        });
      } else {
        this.annotations = this.annotations.map(x => (x.id === this.currentAnnotation.id ? this.currentAnnotation : x));
      }
      this.$bvModal.hide(this.modalId);
      EventBus.$emit("update-annotations", { annotations: this.annotations, name: this.name });
    },

    deleteAnnotation(annotation) {
      this.annotations = this.annotations.filter(x => x.id !== annotation.id);
      EventBus.$emit("update-annotations", { annotations: this.annotations, name: this.name });
    },
  },
  computed: {
    modalId() {
      return `annotations-${this.name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.ann-icon {
  display: inline-block;
  margin-left: 0.2em;
  margin-right: 0.2em;
  color: #484848;
  cursor: pointer;
}

.list-item {
  padding: 0.3em;
  margin: 0.4em;
  background-color: white;
  text-align: left;
  box-shadow: 0px 0px 2px #7a7a7a;
  border-radius: 5px;
}
</style>
